<template>
  <div
    class="vehicle-info"
    :class="{ 'vehicle-info--compact': isCompact }">
    <img class="vehicle-info__icon" :src="imageUrl" />
    <div class="vehicle-info__text" v-if="isManufacturerRangeValid">
      <span> {{ currentRange.manufacturerName }} </span>
      {{ currentRange.rangeName }}
      {{ specificName }}
    </div>
  </div>
</template>

<script lang='ts'>
import {
  Component, Prop, Vue, Watch
} from 'vue-property-decorator';
import {
  State, Getter, Action, Mutation, namespace
} from 'vuex-class';
import Derivative from '@/models/vehicle/derivative';
import VehicleLevel from '../../enums/VehicleLevel';

const VehicleModule = namespace('vehicleModule');
const SearchQueryModule = namespace('searchQueryModule');

@Component
export default class VehicleInfoComponent extends Vue {
  @Prop({ default: false })
  public isCompact!: boolean;

  @VehicleModule.Getter public currentRange;

  @VehicleModule.Getter public currentBodyStyle!: Derivative| null;

  @SearchQueryModule.Getter public searchQuery;

  public get vehicleType(): string {
    return this.searchQuery.vehicleType === 1 ? 'car' : 'van';
  }

  public get imageUrl() : string {
    if (this.currentRange !== null && this.currentRange.manufacturerName !== null) {
      return `//image.uk-tla.com/api/v1/image/vehicle/${this.vehicleType}/${this.currentRange.manufacturerNameSlug}/logo/280`;
    }
    return '';
  }

  public get isManufacturerRangeValid() : boolean {
    return this.currentRange !== null && this.currentRange.manufacturerName !== null && this.currentRange.rangeName !== null;
  }

  public get specificName(): string {
    if (this.currentBodyStyle) {
      if (this.searchQuery.vehicleLevel === VehicleLevel.Derivative) {
        return `${this.currentBodyStyle.modelName} ${this.currentBodyStyle.derivativeName}`;
      }

      return `${this.currentBodyStyle.modelName} ${this.searchQuery.trims ? this.searchQuery.trims[0] : ''}`;
    }

    return '';
  }
}
</script>
